module.exports = __webpack_public_path__ + "assets/3718724f61a0e0327b33f1bde1e9566a.mp4";